/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import { Switch, NavLink, Route } from 'react-router-dom';
import HomePage from './HomePage';
import AboutPage from './AboutPage';
import NotFoundPage from './NotFoundPage';
import logo from '../assets/parkpal-logo.jpg'
import LoginPage from '../containers/LoginPage';
import SignUpPage from '../containers/SignUpPage';
import WelcomePage from '../containers/WelcomePage';
import TopUpEwalletContainer from './../containers/TopUpEwalletContainer';
import PrepaidCardCantainer from './../containers/PrepaidCardCantainer';
import CreditCardContainer from './../containers/CreditCardContainer';
import SimpleCreditCardPage from './../containers/SimpleCreditCardPage';
import SettingsPage from './../containers/SettingsPage';
import HistoryContainer from './../containers/HistoryContainer';
import InfoRow from '../components/InfoRow';
import  HeaderApp  from './Header';
import { Container, Row, Col } from 'reactstrap';
import { connect } from 'react-redux';
import T from 'i18n-react';
import englishTranslation from '../i18n/en';
import greekTranslation from '../i18n/el';
import ReactLoading from 'react-loading';

// This is a class-based component because the current
// version of hot reloading won't hot reload a stateless
// component at the top-level.

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showInfoRow: false
    };
    var locale = require('browser-locale')();
    console.log('locale ', locale);
    if (locale && locale.includes('el')){
          console.log('set greek ');
      T.setTexts(greekTranslation);
      localStorage.setItem('lang', 'GRE');
    }else{
      T.setTexts(englishTranslation);
      console.log('set eng ');
      localStorage.setItem('lang', 'ENG');
    }

  }

  onLogoutClick = (e) => {
    console.log('logout');
    const { router } = this.context;
    router.history.push('/');
    localStorage.removeItem('accountId');
    this.setState({
      showInfoRow: false
    });

  }

  componentWillMount(){
    let accountId = localStorage.getItem('accountId');
    console.log('componentWillMount', accountId);
    if (accountId){
      this.setState({
        showInfoRow: true
      });
    }
  }

  render() {
    const activeStyle = { color: 'blue' };
    return (
      <div>
        <div className="container outside-container" id="generalContainer">
          <HeaderApp />
            <div className="container inside-container">
              <Switch>
                <Route exact path="/" component={HomePage} />
                <Route path="/about" component={AboutPage} />
                <Route path="/login" component={LoginPage} />
                <Route path="/signup" component={SignUpPage} />
                <Route path="/welcome" component={WelcomePage} />
                <Route path="/settings" component={SettingsPage} />
                <Route path="/prepaidCard" component={PrepaidCardCantainer} />
                <Route path ="/creditCard" component={CreditCardContainer} />
                <Route path ="/simpleCreditCard" component={SimpleCreditCardPage} />
                <Route path="/topUpEwallet" component={TopUpEwalletContainer} />
                <Route path="/history"  component={HistoryContainer} />
                <Route component={NotFoundPage} />
              </Switch>
          </div>
        </div>
    </div>
    );
  }
}

App.contextTypes = {
  router: React.PropTypes.object
}

App.propTypes = {
  children: PropTypes.element
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js